<template>
  <div class="card mt-3">
    <div class="card-header border-0">
      <h5 class="card-title">قیمت گذاری</h5>
    </div>
    <div class="card-body">
      <InputGroup label-padding="0px" col1="3" col2="9" label="قیمت واحد" required>
        <b-form-input :value="realValue.unitPrice | priceinput" @input="value=>{realValue.unitPrice = value !== '' ? +value.replace(/\D/g, '') : ''}"
                      type="text" placeholder="قیمت واحد"/>
      </InputGroup>
      <template v-if="hasPermission('read_purchase_price')">
        <InputGroup label-padding="0px" col1="3" col2="9" label="قیمت خرید">
          <b-form-input :value="realValue.purchasePrice | priceinput" @input="value=>{realValue.purchasePrice = value !== '' ? +value.replace(/\D/g, '') : ''}"
                        type="text" placeholder="قیمت خرید"/>
        </InputGroup>
      </template>
      <InputGroup label-padding="0px" col1="3" col2="9" label="تخفیف">
        <Discount v-model="realValue" />
      </InputGroup>
      <InputGroup label-padding="0px" col1="3" col2="9" label="تعداد آستانه">
        <b-form-input type="number" min="0" v-model="realValue.thresholdQuantity"/>
      </InputGroup>
      <InputGroup label-padding="0px" col1="3" col2="9" label="تاریخ آستانه">
        <date-picker type="date" v-model="realValue.thresholdDate" format="YYYY/MM/DD"
                   display-format="jYYYY/jMM/jDD" color="#3366ff" />
      </InputGroup>
    </div>
  </div>
</template>

<script>
import ProductPricingImpl from '@@/core/components/product/small-cards/ProductPricing/ProductPricingImpl'
export default {
  extends: ProductPricingImpl
}
</script>

<style scoped>

</style>
